<template lang="pug">
  v-row(no-gutters)
    v-col(cols=12, md=4).pt-3
      n-datepicker-range(
        :date-range='dateRange'
        @setDateRange='setDateRange'
      )
    v-col(cols=12).pt-3
      n-data-table-card-result(
        :headers='headers'
        :items='items'
        :meta='meta' 
        @nextpage='nextpage'
      ) 
        template(#item.rightActionEffectToCard='{item}')
          | {{ item.created_at | dateFormat}} 

    loading-status(:had-data='hadData')
</template>

<script>  
import { credits as apiCredits } from '@/apis'

export default { 
  data: () => ({
    items : [],
    hadData : false,
    page:1,
    meta:{},
    dateRange :['',''], 
    headers:[  
      { text: 'table.date', value: 'rightActionEffectToCard'},
      { text: 'table.type', value: 'transaction_type.name' },
      { text: 'table.amount', value: 'request_amount', format:'currency' },
      { text: 'table.status', value: 'status.name' }, 
    ],
  }),  
  methods : {
    setDateRange (value) {  
      this.dateRange = value;
      if(this.dateRange[1]!==''){ 
        this.$ga.event('Button', 'SelectDateRange', 'TransactionsPage','' );
        this.load ();
      } 
    },
    async load (params = {}) {
      params = {
        page : this.page,
        start_date : this.dateRange[0],
        end_date : this.dateRange[1]
      }

      this.hadData = false;  
      const [err, data, ,meta] = await apiCredits.get(params) 
      this.hadData = true;  

      if(err) {
        this.$alert('',err,'warning');
        return
      }
      this.items = data;
      this.meta =  meta;      
    },

    nextpage (value) {
      this.page = value;
      this.load ();
    }
  }
};
</script>